export default "__VITE_ASSET__0dd24773__"